/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tough_Many_Okapi_DazzleInputs */

const fr_tough_many_okapi_dazzle = /** @type {(inputs: Tough_Many_Okapi_DazzleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de participants :`)
};

/**

* @param {Tough_Many_Okapi_DazzleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tough_many_okapi_dazzle = /** @type {((inputs?: Tough_Many_Okapi_DazzleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tough_Many_Okapi_DazzleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tough_many_okapi_dazzle(inputs)
});